import React from 'react';
import {
  Box,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  alpha,
  lighten,
  useTheme,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import EmployeeName from '../../../components/EmployeeName';
import EmptyRow from './EmptyRow';
import IdCardIndicator from './IdCardIndicator';
import SectionHeader from './SectionHeader';

export default function NoCheckinTable({ rows, accentColor }) {
  const theme = useTheme();

  return (
    <Box sx={{ mb: 1 }}>
      <SectionHeader accentColor={accentColor} title="พนักงานที่ไม่ได้ลงเวลา" count={rows.length} />
      <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 320 }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={{ bgcolor: lighten(accentColor, 0.88), fontWeight: 700 }}>ชื่อ</TableCell>
              <TableCell sx={{ bgcolor: lighten(accentColor, 0.88), fontWeight: 700 }}>แผนก / ตำแหน่ง</TableCell>
              <TableCell align="right" sx={{ bgcolor: lighten(accentColor, 0.88), fontWeight: 700 }}>ขาดติดต่อกัน</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length === 0 && (
              <EmptyRow colSpan={3} icon={<CheckCircleIcon color="success" />} text="ไม่มีใครขาดลงเวลา" />
            )}
            {rows.map((row, idx) => (
              <TableRow key={row.employee} hover sx={{ bgcolor: idx % 2 === 1 ? alpha(theme.palette.text.primary, 0.02) : 'transparent' }}>
                <TableCell sx={{ display: 'flex', alignItems: 'center' }}>
                  <IdCardIndicator hasIdCard={row.has_id_card} />
                  <EmployeeName id={row.employee} name={row.name} />
                </TableCell>
                <TableCell>{row.department} {row.role}</TableCell>
                <TableCell align="right">
                  <Chip size="small" color="error" variant="outlined" label={`ขาด ${row.monthsWithoutCheckin} เดือน`} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
